import { render, staticRenderFns } from "./best-order-details.component.vue?vue&type=template&id=ff4afc6c&scoped=true"
import script from "./best-order-details.component.vue?vue&type=script&lang=js"
export * from "./best-order-details.component.vue?vue&type=script&lang=js"
import style0 from "./best-order-details.component.vue?vue&type=style&index=0&id=ff4afc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4afc6c",
  null
  
)

export default component.exports